import OptionSwitch from '@jetshop/core/components/OptionSwitch';
import ProductVariationContext from '@jetshop/core/components/ProductVariationProvider/ProductVariationContext';
import t from '@jetshop/intl';
import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import getParentOrCanonicalRoute from '@jetshop/ui/Breadcrumbs/getParentsOrCanonicalRoute';
import { Above } from '@jetshop/ui/Breakpoints';
import { SelectDropdown } from '@jetshop/ui/Select';
import { useStockStatus } from '@jetshop/ui/Stock/StockStatusContainer';
import get from 'lodash.get';
import React, { Fragment, useContext, useState } from 'react';
import MaxWidth from '../Layout/MaxWidth';
import { Price } from '../Price';
import AddToCartWrapper from './AddToCart/AddToCartWrapper';
import ImageContainer from './Images/ImageContainer';
import ProductInfo, {
  SectionHeading,
  ProductSectionImage,
  ProductSectionInfo
} from './ProductInfo';
import ProductInfoAccordion from './ProductInfoAccordion';
import ProductPageLoadingState from './ProductPageLoadingState';
import BaseSizePicker from './SizePicker';
import NotifyWhenBack from './StockStatus/NotifyWhenBack';
import StockStatusIndicator from './StockStatus/StockStatusIndicator';
import StockOrb from './StockStatus/StockOrb';
import ChannelContext from '@jetshop/core/components/ChannelContext';

import ProductVariants from '../Theme/ProductVariants';
import RelatedProducts from '../Theme/RelatedProducts';
import ReadMore from '../Theme/ReadMore';
import { StyleBreadcrumbProd } from '../Theme/StyleBreadcrumb';
import styled from 'react-emotion';
import { Link } from 'react-router-dom';
import ItemsUSP from '../Theme/ItemsUSP';

import {
  ArticleNumber,
  Container,
  ContainerInner,
  Heading,
  ProductContainer,
  ProductDetailsWrapper
  //SubHeading
} from './styledComponents';
import Helmet from 'react-helmet-async';

const StyledSelectDropdown = styled(SelectDropdown)`
  button,
  div {
    background: ${({ theme }) => theme.colors.themeGrey};
    border: none;
  }

  button {
    border: none;
    color: ${({ theme }) => theme.colors.themeBlack} !important;

    &:focus {
      border: none;
    }

    h4 {
      margin-left: 48px;
      font-size: 1rem;
      margin-top: 3px;
    }
  }
`;
const StyledBreadcrumbs = styled(Breadcrumbs)`
  ${StyleBreadcrumbProd}
`;

const OptionWrapper = styled('div')`
  position: relative;
  width: 100%;

  .stock-badge {
    position: absolute;
    bottom: 33px;
    left: 16px;
    z-index: 4;
  }
`;

const GuideLink = styled(Link)`
  position: absolute;
  top: 0;
  right: 0;
  color: #000;
  ${({ theme }) => theme.below.md} {
    display: block;
    margin-bottom: 0.5rem;
    text-align: right;
  }
`;

const ProductUspHolder = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  > div {
    flex: 0 1 auto;
    margin-right: 0.5rem;
    margin-left: 0;
    color: ${({ theme }) => theme.colors.black};
    &:last-of-type {
      margin-right: 0;
    }
    svg {
      flex: 1 0 12px;
      fill: ${({ theme }) => theme.colors.black};
    }
  }
`;

const PickerWrapper = styled('div')`
  width: 100%;
  position: relative;
  h2 {
    display: none;
  }

  .stock-badge {
    bottom: 16px;
    left: 16px;
  }
  .stock-status-text {
    margin-left: 2rem;
    top: 22px;
    position: absolute;
  }
`;

const ColorPicker = ({ option, ...props }) => (
  <Fragment>
    <SectionHeading>{option.name}</SectionHeading>
    <SelectDropdown {...props} className={'ColorPicker'} />
  </Fragment>
);

const SizePicker = ({ option, ...props }) => (
  <Fragment>
    <SectionHeading>{option.name}</SectionHeading>
    <BaseSizePicker {...props} />
  </Fragment>
);

const DefaultPicker = ({ option, ...props }) => {
  const itemsWithStatus = (props.items || []).map(item => {
    const isBuyable =
      item.variant &&
      item.variant.stockStatus &&
      item.variant.stockStatus.buyable;
    const stockStatus = isBuyable ? 'inStock' : 'outOfStock';

    const stockStatusIcon = (
      <StockOrb className="stock-badge" status={stockStatus} badge={true} />
    );

    return {
      ...item,
      text: (
        <>
          <span class="stock-status-icon">{stockStatusIcon} </span>
          <span class="stock-status-text">{item.value}</span>
        </>
      )
    };
  });

  return (
    <PickerWrapper>
      <GuideLink to={'/storleksguide'}>{t('Sizeguide')}</GuideLink>
      <SectionHeading>{t('Size')}</SectionHeading>
      <StyledSelectDropdown
        defaultSelectedItem={itemsWithStatus[0]}
        {...props}
        items={itemsWithStatus}
        className={'SizePicker'}
      />
    </PickerWrapper>
  );
};

function getBrand(product) {
  const field = product.customFields.find(({ key }) => key === 'brand');
  if (field) {
    return field.stringValue;
  }
}

const ProductMeta = ({ product, selectedVariation }) => {
  const { selectedChannel } = useContext(ChannelContext);

  const prod = selectedVariation || product;
  const brand = getBrand(product);

  return (
    <Helmet>
      <meta property="og:title" content={product.name} />
      <meta
        property="product:original_price:amount"
        content={prod.price.incVat}
      />
      <meta
        property="product:price:amount"
        content={prod.previousPrice.incVat}
      />
      <meta
        property="og:price:currency"
        content={selectedChannel.currency.name}
      />
      <meta
        property="og:image"
        content={product.images.length && product.images[0].url}
      />
      <meta
        property="product:availability"
        content={prod.stockStatus.buyable ? 'instock' : 'oos'}
      />
      {brand && <meta property="product:brand" content={brand} />}
      <meta
        property="product:category"
        content={product.canonicalCategory.name}
      />
      <meta
        property="og:url"
        content={`${selectedChannel.url}${product.primaryRoute.path}`}
      />
    </Helmet>
  );
};

/*
state = {
  activeTab: 0
};

componentDidUpdate(prevProps, newProps) {
  console.log(prevProps.activeTab === newProps.activeTab);

  prevProps.activeTab != this.props.activeTab && this.setState({ activeTab: 0 });
}

selectTab = e => {
  this.setState({ activeTab: e.target.value });
};
*/

const Product = ({ result: { data, loading }, product, cacheHit }) => {
  const tabContainerElement = React.createRef();

  const { selectedVariation } = useContext(ProductVariationContext);
  const stockStatus = useStockStatus(selectedVariation || product);
  const [activeTab, setActiveTab] = useState(0);

  // Return early if there is no cache hit
  if (!cacheHit)
    return (
      <ProductContainer>
        <ProductPageLoadingState />
      </ProductContainer>
    );

  // These constants are only used if we have data
  const images = get(product, 'images', []);
  const parents = getParentOrCanonicalRoute(data.route.parents, product);

  const readMoreAction = () => {
    setActiveTab(0);
    //.querySelector('.css-pzgsuq-TabContainer')
    const destinationOffset = document
      .querySelector('.firstButton')
      .getBoundingClientRect().top;
    const documentOffset = document.body.getBoundingClientRect().top * -1;
    const scrollToPosition = documentOffset + destinationOffset - 66;

    let scrollPosition = documentOffset;

    function scroll() {
      if (typeof window !== 'undefined') {
        scrollPosition =
          scrollPosition + 40 > scrollToPosition
            ? scrollToPosition
            : scrollPosition + 40;
        window.scrollTo(0, scrollPosition);

        if (scrollPosition >= scrollToPosition) {
          return;
        }

        requestAnimationFrame(scroll);
      }
    }
    scroll();
  };

  const selectTab = event => {
    setActiveTab(event.currentTarget.value);
  };

  return (
    <ProductContainer>
      <>
        <MaxWidth>
          <StyledBreadcrumbs
            parents={parents}
            breadcrumbText={product.breadcrumbText}
          />
        </MaxWidth>
        <Container>
          <ContainerInner>
            <ProductMeta {...{ product, selectedVariation }} />
            <ProductSectionImage>
              <ImageContainer
                product={product}
                images={images}
                badges={product.badges}
              />
            </ProductSectionImage>
            <ProductSectionInfo>
              <ProductDetailsWrapper>
                <Heading data-testid="product-title">
                  {product.name || 'Loading...'}
                </Heading>
                {/*<SubHeading>{product.subName}</SubHeading>*/}
                <ArticleNumber>
                  <span>{t('Art nr.')}</span>
                  <span>{product.articleNumber}</span>
                </ArticleNumber>

                <Above breakpoint="md">
                  {matches =>
                    matches && (
                      <ReadMore
                        textString={product.description}
                        shortDescriptionLength={12}
                        concatSymbol={' ...'}
                        readMoreAction={readMoreAction}
                      />
                    )
                  }
                </Above>

                <Price
                  previousPrice={(selectedVariation || product).previousPrice}
                  price={(selectedVariation || product).price}
                />

                {product.variants && product.variants.options ? (
                  // If there are product variants, display the
                  // variant selector
                  <OptionWrapper>
                    <ProductVariants
                      primaryRoute={product.primaryRoute}
                      articleNumber={product.articleNumber}
                    />
                    <StockOrb
                      className="stock-badge"
                      status={stockStatus.status}
                      badge={true}
                    />

                    <OptionSwitch
                      options={product.variants.options}
                      components={{
                        Färg: ColorPicker,
                        Storlekar: SizePicker,
                        Size: SizePicker,
                        default: DefaultPicker
                      }}
                    />
                  </OptionWrapper>
                ) : null}

                {stockStatus.status === 'notifyWhenBack' ? (
                  <NotifyWhenBack
                    text={stockStatus.text}
                    articleNumber={(selectedVariation || product).articleNumber}
                  />
                ) : (
                  <AddToCartWrapper
                    product={product}
                    stockStatus={stockStatus}
                  />
                )}

                <StockStatusIndicator
                  status={stockStatus.status}
                  text={stockStatus.text}
                />

                <ProductUspHolder>
                  <ItemsUSP type={'ProductPage'} />
                </ProductUspHolder>
              </ProductDetailsWrapper>
            </ProductSectionInfo>

            <Above breakpoint="md">
              {matches =>
                matches ? (
                  <div
                    css={`
                      width: 100%;
                    `}
                    ref={tabContainerElement}
                  >
                    <ProductInfo
                      product={product}
                      activeTab={activeTab}
                      selectTab={selectTab}
                    />
                  </div>
                ) : (
                  <ProductInfoAccordion product={product} />
                )
              }
            </Above>
          </ContainerInner>
        </Container>
      </>
      {product.relatedProducts && (
        <RelatedProducts relatedProducts={product.relatedProducts} />
      )}
    </ProductContainer>
  );
};

export default Product;
